var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDissertation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    rx: 61.5,
    fill: "#38419A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_1835",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 42,
    width: 39,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 42.5H80.5V80.5H42.5V42.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_1835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1918 46.7366H43.242V75.6853H58.0561C58.7168 76.9096 60.0112 77.7416 61.5 77.7416C62.9888 77.7416 64.2832 76.9096 64.9439 75.6853H79.7579V46.7366H76.8082",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8083 62.8768V46.7335L73.4115 45.2584H63.4596C62.3774 45.2584 61.5 46.1358 61.5 47.2181C61.5 46.1358 60.6226 45.2584 59.5404 45.2584H49.5885L46.1918 46.7335V72.7839H76.8083",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2345 60.2726H51.0035V51.0373H71.9965V60.2726",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5945 55.9951H55.219V57.8684C55.219 58.0896 54.9493 58.2002 54.6798 58.2002C54.4101 58.2002 54.1406 58.0896 54.1406 57.8684V53.4719C54.1406 53.2438 54.4101 53.147 54.6798 53.147C54.9493 53.147 55.219 53.2438 55.219 53.4719V55.1655H56.5945V53.4719C56.5945 53.2438 56.8642 53.147 57.1338 53.147C57.4033 53.147 57.6729 53.2438 57.6729 53.4719V57.8684C57.6729 58.0896 57.4033 58.2002 57.1338 58.2002C56.8642 58.2002 56.5945 58.0896 56.5945 57.8684V55.9951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 55.2553H60.535C60.7424 55.2553 60.8599 55.4558 60.8599 55.6771C60.8599 55.8636 60.7631 56.0849 60.535 56.0849H59.4981V57.2601H61.3507C61.5581 57.2601 61.6755 57.4812 61.6755 57.7371C61.6755 57.9582 61.5788 58.2002 61.3507 58.2002H58.8898C58.6547 58.2002 58.4197 58.0896 58.4197 57.8684V53.4788C58.4197 53.2576 58.6547 53.147 58.8898 53.147H61.3507C61.5788 53.147 61.6755 53.389 61.6755 53.6101C61.6755 53.8659 61.5581 54.0871 61.3507 54.0871H59.4981V55.2553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6157 58.2002C62.3807 58.2002 62.1456 58.0896 62.1456 57.8684V53.4719C62.1456 53.2438 62.4153 53.147 62.6848 53.147C62.9544 53.147 63.224 53.2438 63.224 53.4719V57.2601H64.8001C65.0075 57.2601 65.1112 57.4951 65.1112 57.7302C65.1112 57.9651 65.0075 58.2002 64.8001 58.2002H62.6157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6252 54.0871V55.5457H67.3096C67.6967 55.5457 67.9318 55.3245 67.9318 54.8545V54.7784C67.9318 54.3083 67.6967 54.0871 67.3096 54.0871H66.6252ZM65.5468 53.4719C65.5468 53.2991 65.7058 53.147 65.9477 53.147H67.3787C68.2911 53.147 69.0101 53.5756 69.0101 54.7369V54.7715C69.0101 55.9328 68.2635 56.3752 67.3096 56.3752H66.6252V57.8684C66.6252 58.0896 66.3556 58.2002 66.0859 58.2002C65.8165 58.2002 65.5468 58.0896 65.5468 57.8684V53.4719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0035 63.5433H56.9727",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0035 67.2543H56.9727",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0273 63.5433H71.9965",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0273 67.2543H71.9965",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissertation);
export default __webpack_public_path__ + "static/media/dissertation.cfe855d206c0ed529377456768461eaf.svg";
export { ForwardRef as ReactComponent };